import { render, staticRenderFns } from "./DataDiscovery.vue?vue&type=template&id=6b48e307&"
import script from "./DataDiscovery.vue?vue&type=script&lang=js&"
export * from "./DataDiscovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports